const jumpNavBlocks = document.querySelectorAll(
	'.block-locations-jump-navigation'
) as NodeListOf<HTMLElement>;

/**
 * Get sticky top offset in pixels from CSS (--nav-height, set on body e.g. body.admin-bar).
 */
function getStickyTopOffset(): number {
	const el = document.body || document.documentElement;
	const value = getComputedStyle(el).getPropertyValue('--nav-height').trim();
	if (!value) return 0;
	const parsed = parseFloat(value);
	return Number.isNaN(parsed) ? 0 : parsed;
}

jumpNavBlocks.forEach((block: HTMLElement) => {
	const button = block.querySelector('.block-locations-jump-navigation__button');
	const nav = block.querySelector('.block-locations-jump-navigation__container');
	const links = block.querySelectorAll(
		'.block-locations-jump-navigation__container nav ul li a'
	) as NodeListOf<HTMLElement>;

	function checkStuck(): void {
		const topOffset = getStickyTopOffset();
		const blockTop = block.getBoundingClientRect().top;
		const isStuck = Math.abs(blockTop - topOffset) < 2;
		block.classList.toggle('is-stuck', isStuck);
	}

	let ticking = false;
	function onScrollOrResize(): void {
		if (!ticking) {
			requestAnimationFrame(() => {
				checkStuck();
				ticking = false;
			});
			ticking = true;
		}
	}

	window.addEventListener('scroll', onScrollOrResize, { passive: true });
	window.addEventListener('resize', onScrollOrResize);
	checkStuck();

	links.forEach((jumpLink: HTMLElement) => {
		jumpLink.addEventListener('click', () => {
			if (window.innerWidth <= 991) {
				button?.setAttribute('aria-expanded', 'false');
				nav?.setAttribute('aria-expanded', 'false');
				links.forEach((link: HTMLElement) => {
					link.setAttribute('aria-expanded', 'false');
				});
			}
		});
	});
});
